import { isEqual } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { useAllCountryOptions } from '@anytag/shared-hooks';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys, InfluencersFilterFormValues } from '../schemaTypes';

type CountriesFieldProps = Omit<
  MultipleSelectorFieldProps<InfluencersFilterFormKeys>,
  'name' | 'multiple' | 'options' | 'onChange'
>;

export const CountriesField = ({ className, ...restProps }: CountriesFieldProps) => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<InfluencersFilterFormValues>();
  const { allCountryOptions } = useAllCountryOptions({ hasAllCountryOption: false });

  const countryIdsValue = watch('countryIds');

  return (
    <SelectorField<InfluencersFilterFormKeys>
      clearable={false}
      name="countryIds"
      options={allCountryOptions}
      className={cn('max-w-34.5', className)}
      placeholder={t<string>('Selector.Countries')}
      onChange={(name, value) => {
        setValue(name, value);

        if (!isEqual(value, countryIdsValue)) {
          setValue('regionIds', []);
          setValue('provinceIds', []);
        }
      }}
      multiple
      {...restProps}
    />
  );
};
